import {
  WAREHOUSES_FETCH_STARTED,
  WAREHOUSES_FETCH_SUCCEEDED,
  WAREHOUSES_FETCH_FAILED,
  WAREHOUSES_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  warehouses: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case WAREHOUSES_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case WAREHOUSES_FETCH_SUCCEEDED:
      return {
        ...state,
        status: statuses.succeeded,
        warehouses: action.payload
      };
    case WAREHOUSES_FETCH_FAILED:
      return { ...state, status: statuses.failed, warehouses: [], error: action.error };
    case WAREHOUSES_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
